/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React from 'react';
import ControllerContainer from 'pages/dashboard/embeds/management/customize/controllercontainer/controllercontainer';
import Title from 'material/copy/title/title';
import ColorPicker from 'material/embeds/colorpicker/colorpicker';
//import individual content types to display
import QuestionProperties from 'pages/dashboard/embeds/management/customize/pageproperties/questionproperties/questionproperties_container';
import StoryProperties from 'pages/dashboard/embeds/management/customize/pageproperties/storyproperties/storyproperties_container';
// styles
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/embeds/management/customize/pageproperties/pageproperties_styles';


/* ========== ~~~~~~~~~~ PAGE PROPERTIES : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
const PageProperties = (props) => {

    const renderContentType = () => {
        switch (props.contentType) {
            case 'story':
                return <StoryProperties />
            case 'quiz':
            case 'poll':
            default:
                return <QuestionProperties contentType={props.contentType} />
        }
    }

    const showPlacement = () => props.location === 'in-content' ? 'incontent' : 'rail';

    const setBackgroundColor = (color) => (props.setCurrentUniqueProperty(props.contentId, 'backgroundColor', color));

    return (
        <div className={`pageproperties ${props.classes.pageproperties} ${showPlacement()} ${props.noLiveContents ? 'greyOut' : ''}`}>
            <ControllerContainer>
                <Title>
                    <h4>{props.contentType ? props.contentType.charAt(0).toUpperCase() + props.contentType.slice(1) : 'Quiz'} Formatting</h4>
                </Title>
                <div className={'selectedContentType'}>
                    {renderContentType()}
                </div>
                <div className={`background`}>
                    <Title>
                        <h4>Background Color:</h4>
                    </Title>
                    <ColorPicker fadeInRight={true} color={props.backgroundColor} processColorUpdate={setBackgroundColor} />
                </div>
            </ControllerContainer>
        </div >
    );
}

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// will be utilized in parent component after being infused with app state & actions
export default injectSheet(styles)(PageProperties);
